import React, { FC } from 'react';
import EntityDetailLayout from 'app/components/EntityDetailLayout';
import { PostModalOnClose } from 'app/modules/posts/modules/post/hooks/usePostModal';
import { Icon, IconButton } from '@kontentino/ui';
import { faClose } from '@fortawesome/pro-regular-svg-icons/faClose';
import Skeleton from 'react-loading-skeleton';

type Props = {
  onClose: PostModalOnClose;
};

const ComposerSkeleton: FC<Props> = ({ onClose }) => {
  return (
    <EntityDetailLayout
      header={
        <div className="tw-flex tw-items-center tw-py-4 tw-pl-8 tw-pr-6">
          <Skeleton width={200} height={28} />
          <div className="tw-ml-auto">
            <IconButton
              variant="secondary"
              size="small"
              onClick={() => onClose()}
              icon={<Icon icon={faClose} />}
            />
          </div>
        </div>
      }
      contentLeft={
        <div className="tw-pl-[10%]">
          <Skeleton height={500} width={'80%'} />
        </div>
      }
      contentRight={
        <>
          <Skeleton height={200} />
          <Skeleton height={200} />
          <Skeleton height={200} />
          <Skeleton height={200} />
        </>
      }
      footer={<Skeleton height={60} />}
    />
  );
};

export default ComposerSkeleton;
